export default[
  {
    title: "Snaliens", 
    categories: ["unity"],
    img: "https://i.imgur.com/FwdVF7C.png", 
    media: [
      "https://www.youtube.com/embed/PZecVaFgOzI?rel=0&amp;autoplay=1&mute=1", 
      "https://i.imgur.com/qOKjAxJ.png",
      "https://i.imgur.com/Ahtabv4.gif",
      "https://i.imgur.com/ri7SirF.gif",
      "https://i.imgur.com/4MozHlF.gif",
      "https://i.imgur.com/wQLN2sq.gif"
    ], 
    body:
    `[Website](./#/snaliens) | [Steam](https://store.steampowered.com/app/1214850/Snaliens/) | [itch.io](https://jferreira.itch.io/snaliens) | [Google Play](https://play.google.com/store/apps/details?id=com.JFerreira.Snaliens)

A group of Snaliens just collapsed on an unexplored planet and now they need your help! Help them to reunite and escape by solving intricate puzzles. 

## Features
- Complete Over 50 Levels
- Non-Linear World Map
- Manipulate different devices
- Pickup and connect different powered parts
- Play using only one input system mouse/gamepad/keyboard
`
  },
  {
    title: "WebGen", 
    categories: ["python"],
    img: "https://i.imgur.com/bkhR0vo.png", 
    media: [
      "https://i.imgur.com/nUdGgHp.mp4", 
      "https://i.imgur.com/oFGZtu6.mp4",
      "https://i.imgur.com/SNTIOZ7.mp4",
      "https://i.imgur.com/zLPqA8J.png",
      "https://i.imgur.com/so3emh6.png",
      "https://i.imgur.com/dAIzeP0.png",
      "https://i.imgur.com/qErBUfe.png",
    ], 
    body:
    `[Github](https://github.com/joaocsf/WebGen)

Automatically Transform Hand-Drawings into Prototypes.
Developed During my Master's Thesis.

## Features

- Support for annotations to control the generated prototype
- Generic pipeline to extend and experiment
- Container segmentation approach
- Hierarchy inference algorithm based on element positioning
`
  },
  {
    title: "MockGen", 
    categories: ["python"],
    img: "https://i.imgur.com/6AiPmHb.png", 
    media: [
      "https://i.imgur.com/W5BYzA9.png", 
      "https://i.imgur.com/eL9Cgub.png",
      "https://i.imgur.com/T836dMq.png",
      "https://i.imgur.com/TG51GdV.png",
    ], 
    body:
    `[Github](https://github.com/joaocsf/MockGen) | [Website](https://mockgen.herokuapp.com)

A Synthetic Mockup Generation Tool
Developed During my Master's Thesis.

## Features

- Generate large number of mockups
- Create custom annotations
- Generate datasets for segmentation and detection porpuses

`
  },
  {
    title: "Shell Search", 
    categories: ['unity'],
    img: "https://i.imgur.com/t0pLIMI.png", 
    media: [
      "https://www.youtube.com/embed/zQ8tWZuB0l8?rel=0&amp;autoplay=1&mute=1", 
      "https://i.imgur.com/vaXnSeh.gif",
      "https://i.imgur.com/T1Zu2jl.gif", 
      "https://i.imgur.com/Pcm5eB7.gif",
      "https://i.imgur.com/SulVv8P.gif",
      "https://i.imgur.com/t0pLIMI.png",
      "https://i.imgur.com/ZJIc7ca.png",
    ], 
    body:
    `[Github](https://github.com/joaocsf/FEUP_DJCO_FINAL)

Game Developed During the DJCO class @ FEUP
## Features

- Custom shaders
- World transitions based on scale
- Possession of different objects
- Custom grid system
- Custom animation and physics systems
- Non-linear progression
- Reactive soundtrack
- Deformable grass
- Undo logic
`
  },
  {
    title: "Library Ascent", 
    categories: ['unity'],
    img: "https://i.imgur.com/sDjWcBa.png", 
    media: [
      "https://www.youtube.com/embed/NrvZG8ZlcPM?rel=0&amp;autoplay=1&mute=1", 
      "https://i.imgur.com/5DmcUin.gif",
      "https://i.imgur.com/93Qey7n.gif"
    ], 
    body: 
`[Github](https://github.com/joaocsf/FEUP-DJCO)

Game Developed During the DJCO class @ FEUP
## Features

- Procedural level generator
- Animations
- Screen shake
- Explosion warp shader
- Custom camera transitions
- Character costumization
- Different powerups
`
  },
  {
    title: "Concert App", 
    categories: ['android'],
    img: "https://i.imgur.com/Ii8Uap8.png", 
    media: [
      "https://i.imgur.com/hG7VLkK.png", 
      "https://i.imgur.com/s581TqA.png",
      "https://i.imgur.com/E4TocIE.png",
      "https://i.imgur.com/PSQ4O1f.png",
      "https://i.imgur.com/prIMC56.png",
      "https://i.imgur.com/S1b5Oxe.png",
      "https://i.imgur.com/WYC6ZiD.png",
      "https://i.imgur.com/Ii8Uap8.png",
    ], 
    body: 
`[Github](https://github.com/joaocsf/FEUP-CMOV)

App to manage tickets and bar discounts
Developed during the CMOV class @ FEUP
## Features

- Buy tickets for a given concert
- Receive discounts based on purchases
- Make orders at the cafeteria or validate tickets using NFC or QR Codes
- Secure transaction of tickets using public-key encryption
`
  },
  {
    title: "AR Tower Defense", 
    categories: ['unity'],
    img: "https://i.imgur.com/4iCStF3.jpg", 
    media: [
      "https://www.youtube.com/embed/PhUR-AOZKbA?rel=0&amp;autoplay=1&mute=1", 
      "https://i.imgur.com/TEE5ggZ.jpg",
      "https://i.imgur.com/sunhyGy.jpg"
    ], 
    body: 
`

Game Developed During the RVAU class @ FEUP
## Features

- Adjust your height
- Use markers to place towers
- Interactive slingshot
- Grab objects
- Boss stages
- Real world light affects in-game lighting
- Animations
- Custom Artwork
`},
 {
    title: "The Flashlight", 
    categories: ['unity'],
    img: "https://i.imgur.com/z9h8xFn.png", 
    media: [
      "https://www.youtube.com/embed/8APfudLeFxw?rel=0&amp;autoplay=1&mute=1", 
      "https://i.imgur.com/IkhJvOg.png",
      "https://i.imgur.com/pZof5OR.png",
      "https://i.imgur.com/z9h8xFn.png", 
    ], 
    body: 
`
Prototype based on the game [Perspective](https://arcade.digipen.edu/games/perspective)

## Features

- Play with perspective
- FPS meets 2D platform
- Play with shadows
- Different levels to reflect the game mechanics
`},
 {
    title: "Experiments", 
    categories: ['unity'],
    img: "https://i.imgur.com/He6RNs1.png", 
    media: [
      "https://www.youtube.com/embed/rHMQi44TNp0?rel=0&amp;autoplay=1&mute=1", 
      "https://i.imgur.com/uaoPJt0.png",
      "https://i.imgur.com/oSp9SoA.png",
      "https://i.imgur.com/He6RNs1.png", 
      "https://i.imgur.com/G9b6CgW.png", 
      "https://i.imgur.com/yaC4Iws.png", 
      "https://i.imgur.com/AtzxvYb.png", 
    ], 
    body: 
`
A Prototype with custom character and logic editor which enables the player to walk on any surface.

## Features

- Custom node-based logic editor with a real-time debugger
- Custom character movement capable of walking on any surface
- Custom water shader
- Footsteps audio based on the surface material
`},
 {
    title: "Space Battlegrounds", 
    categories: ['unity'],
    img: "https://i.imgur.com/LeFi4fH.png", 
    media: [
      "https://i.imgur.com/pLbIEjR.gif", 
      "https://i.imgur.com/LWVSkil.gif", 
      "https://i.imgur.com/N7Sd14U.png",
      "https://i.imgur.com/LeFi4fH.png", 
      "https://i.imgur.com/RV8fOwX.png", 
      "https://i.imgur.com/KDjpI8p.png", 
      "https://i.imgur.com/zaTT3QV.png", 
    ], 
    body: 
`
Small prototype where teams cooperate to control a space ship to battle each other

## Features

- Custom network code built upon Unity's LLAPI
- Movement replication
- Radial menu
- Custom player shading
- Mountable turrets
`},
{
    title: "Dungeon Generator", 
    categories: ['unity'],
    img: "https://i.imgur.com/BmCUz47.png", 
    media: [
      "https://i.imgur.com/TlixqjD.png", 
      "https://i.imgur.com/BxqCsBY.png", 
      "https://i.imgur.com/iuBXQGc.png",
      "https://i.imgur.com/kBhgzLt.png", 
      "https://i.imgur.com/oprD4di.png", 
      "https://i.imgur.com/eufOvY8.png", 
      "https://i.imgur.com/yqkQ9T8.png",
      "https://i.imgur.com/TWeDq7K.png",
      "https://i.imgur.com/6rpbO1n.png",
      "https://i.imgur.com/BmCUz47.png"
    ], 
    body: 
`
Dungeon procedural generator

## Features

- Randomly locked rooms with respective keys
- Custom navmesh generation and navigation solution
- Room decoration using custom meshes
`},
 {
    title: "Top-down Survival", 
    categories: ['unity'],
    img: "https://i.imgur.com/dnrmCvV.png", 
    media: [
      "https://i.imgur.com/11br9WI.gif", 
      "https://i.imgur.com/fT089PU.gif", 
      "https://i.imgur.com/e5p1BIc.png", 
      "https://i.imgur.com/Ibfbtiq.png",
      "https://i.imgur.com/RDA219b.gif", 
      "https://i.imgur.com/6roFiFb.gif", 
      "https://i.imgur.com/o9fvlN9.gif",
      "https://i.imgur.com/EnMqVVC.png",
    ], 
    body: 
`
Prototype with modding support based on components

## Features

- Creation of new items based on existing components
- Creation of blocks and biomes taking temperature and height maps into account
- Screen-space shadows
- Texture atlas packing
`},
 {
    title: "2D Voxel Shooter", 
    categories: ['unity'],
    img: "https://i.imgur.com/d7Piiac.png", 
    media: [
      "https://i.imgur.com/rISAEbk.gif", 
      "https://i.imgur.com/Xkximr6.gif", 
      "https://i.imgur.com/RBqNYX0.gif", 
      "https://i.imgur.com/eVZTlB0.gif",
      "https://i.imgur.com/IXfGZAa.gif", 
      "https://i.imgur.com/d7Piiac.png",
    ], 
    body: 
`
Voxel shooter with a custom level editor

## Features

- Level editor exposing attributes through reflection
- Custom inverse kinematics for the arms and legs of the character
- Destructible terrain
- Dig your battlefield
`},
 {
    title: "3D Voxel Generator", 
    categories: ['unity'],
    img: "https://i.imgur.com/DW7Fgn5.gif", 
    media: [
      "https://i.imgur.com/ekTv9yU.mp4", 
      "https://i.imgur.com/J2l8p3e.mp4", 
      "https://i.imgur.com/xOBa8Z1.png", 
      "https://i.imgur.com/RNOZh8V.mp4",
      "https://i.imgur.com/LglnFDy.mp4",
    ], 
    body: 
`
Multiple experiments compiled related to a 3D custom voxel editor

## Features

- Multithreaded
- Usage of memory pools
- Support for custom meshes
- Custom shaders for wind animation
`},
 {
    title: "Minix Shooter", 
    categories: ['c'],
    img: "https://i.imgur.com/88sI8hC.png", 
    media: [
      "https://i.imgur.com/F5wvbn9.mp4", 
      "https://i.imgur.com/DbvFA4h.mp4", 
      "https://i.imgur.com/88sI8hC.png", 
      "https://i.imgur.com/JfmepMs.png",
      "https://i.imgur.com/q3bcIAr.png",
    ], 
    body: 
`[Github](https://github.com/joaocsf/LCOM)

Top-down shooter programmed in C for the Minix OS

## Features

- Destructible terrain
- Buffer to store dead enemy sprites
- Parsing of timer/keyboard/mouse interrupt signals
- Multiplayer support through UART
- A* Pathfinding
- Custom BMP reader
`}
]